// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u5gg+","footerContent":"Footer_footerContent__BSOz6","footerColumn":"Footer_footerColumn__LrvPR","list":"Footer_list__H6MB-"};